<template>
		<footer class="footer__section footer-section only-web">
			<div class="footer-top">
				<div class="md-layout">
					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
						<div class="footer-item">
							<!-- <span class="footer-title">អំពីយើង</span> -->
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<img src="@/assets/img/logo-menu.png" style="margin: 0 0 15px 0; width: 40%">
									<p class="footer-text">{{$store.state.lang.text.about[$store.state.lang.language]}}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
						<div class="footer-item">
							<span class="footer-title">{{$store.state.lang.text.method[$store.state.lang.language]}}</span>
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<img src="@/assets/img/banners/payment_method.png">
									<!-- <img src="@/assets/img/banners/payment_method.png"> -->
								</div>
							</div>
						</div>
					</div>
					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
						<div class="footer-item">
							<span class="footer-title">{{$store.state.lang.text.about_us[$store.state.lang.language]}}</span>
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-33 md-small-size-50 md-medium-size-50 md-size-50 footer-link">
									<router-link to="/page/open-account">{{$store.state.lang.text.open_account[$store.state.lang.language]}}</router-link>
								</div>
								<div class="md-layout-item md-xsmall-size-33 md-small-size-50 md-medium-size-50 md-size-50 footer-link">
									<router-link to="/page/how-to-play">{{$store.state.lang.text.how_play[$store.state.lang.language]}}</router-link>
								</div>
								<div class="md-layout-item md-xsmall-size-33 md-small-size-50 md-medium-size-50 md-size-50 footer-link">
									<router-link to="/page/deposit-withdraw">{{$store.state.lang.text.deposit_withdraw[$store.state.lang.language]}}</router-link>
								</div>
								<!-- <div class="md-layout-item md-xsmall-size-33 md-small-size-50 md-medium-size-50 md-size-50 footer-link">
									<router-link to="/page/terms-conditions">បទបញ្ញត្កិ</router-link>
								</div> -->
								<div class="md-layout-item md-xsmall-size-33 md-small-size-50 md-medium-size-50 md-size-50 footer-link">
									<router-link to="/page/terms-conditions">{{$store.state.lang.text.terms[$store.state.lang.language]}}</router-link>
								</div>
							</div>
						</div>
					</div>
					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-25">
						<div class="footer-item">
							<span class="footer-title">{{$store.state.lang.text.help[$store.state.lang.language]}}</span>
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<p class="footer-text">{{$store.state.lang.text.help_text[$store.state.lang.language]}}</p>
									<!-- <div class="form__tabs__wrap" style="margin-top: 15px">
										<form style="display: flex;">
											<div class="form__grp" style="width: 70%"><input type="text" placeholder="លេខ​ទូរស័ព្ទ​"></div>
											<div class="create__btn" style="width: 30%;margin-top: 0;margin-bottom: 0;"><a class="cmn--btn" style="width: 100%;padding: 10px 10px 13px;"><span>ស្នើ</span></a></div>
										</form>
									</div> -->
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<div class="social-container">
										<div class="social-icon"><a href="https://www.facebook.com/98mbet"><img src="@/assets/img/socials/facebook.png"></a> </div>
										<div class="social-icon"><a href="https://t.me/bet_98M"><img src="@/assets/img/socials/telegram.png"></a></div>
										<!-- <div class="social-icon"><a href="https://facebook.com"><img src="@/assets/img/socials/wechat.png"></a></div> -->
										<div class="social-icon"><a href="https://www.youtube.com/@98Mbet"><img src="@/assets/img/socials/youtube.png"></a></div>
										<!-- <div class="social-icon"><a href="https://facebook.com"><img src="@/assets/img/socials/instagram.png"></a></div> -->
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer-bottom">{{$store.state.lang.text.copyright[$store.state.lang.language]}}. អ្នកកំពុងលេង {{online}} online</div>
	  </footer>
</template>
<script>
	export default {
		data() {
			return {
				online: "",
				interval: null
			}
		},
		methods: {
		},
		created() {
			// let range = 70;
			this.online = parseInt(Math.random() * (120 - 70 + 1) + 100);
			this.interval = setInterval(() => {
				this.online = parseInt(Math.random() * (140 - 70 + 1) + 100);
			}, 15000)
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
	}
</script>

<style>
.social-container {
	display: flex;
	flex-direction: row;
}
.social-icon {
	width: 32px;
	height: 32px;
	margin: 5px 5px 15px 0;

}
.footer-text {
	font-size: 12px;
	text-align: left;
	width: 100%;
	line-height: 22px;
}
.footer-section {
	padding: 0;
	padding-bottom: 0 !important;
	margin-top: 15px;
	border-radius: 15px;
}
.footer-top {
	padding: 0 0 0 0;
	padding-bottom: 12px;
	/* text-align: center; */
}
.footer-link {
	margin-bottom: 15px;
}
.footer-item {
	width: 100%;
	display: flex;
	flex-direction: column;
	/* align-items: center; */
	margin-top: 25px;
	/* text-align: center; */
}
.footer-title {
	margin-bottom: 15px;
}
.footer-bottom {
	background-color: var(--white-color);
	padding: 15px 0;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue